<template>
  <div class="allergy-kpis__row options-bar">
    <div class="allergy-kpis__filter">
      <StoreConnectedSelect store="allergyKpis" name="year" :options="yearsList"></StoreConnectedSelect>
    </div>
    <div class="allergy-kpis__filter">
      <StoreConnectedSelect store="allergyKpis" name="month" :disabled="monthDisabled" :options="monthsInReport"></StoreConnectedSelect>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';

  export default {
    name: 'Filters',
    components: {
      StoreConnectedSelect,
    },
    mounted() {
      // this.$store.dispatch('allergyKpis/getReport');
    },
    computed: {
      ...mapGetters('allergyKpis', ['month', 'year', 'yearsList', 'monthsInReport', 'activeSection']),
      monthDisabled() {
        return this.activeSection === 'charts';
      },
    },
    watch: {
      year() {
        this.$store.dispatch('allergyKpis/getReport');
      },
      month() {
        this.$store.dispatch('allergyKpis/getComments');
      },
    },
  };
</script>
